import type { Currency, PaymentMethodConfig, PaymentMethodId } from '@/types/payment'
import { ALL_PAYMENT_METHODS, PAYMENT_GATEWAY_METHOD, WALLET_PAYMENT_METHODS } from '@/config/payment'

export function getPaymentMethodById(id: PaymentMethodId): PaymentMethodConfig | undefined {
	return ALL_PAYMENT_METHODS.find((method) => method.id === id)
}

export function getAvailablePaymentMethods(currency: Currency | null | undefined, connectedWalletIds: PaymentMethodId[] = []): PaymentMethodConfig[] {
	if (!currency) {
		return []
	}

	const methods: PaymentMethodConfig[] = []

	if (PAYMENT_GATEWAY_METHOD.isEnabled?.(currency) ?? true) {
		methods.push(PAYMENT_GATEWAY_METHOD)
	}

	for (const walletId of connectedWalletIds) {
		const walletMethod = WALLET_PAYMENT_METHODS[walletId as keyof typeof WALLET_PAYMENT_METHODS]
		if (!walletMethod) {
			continue
		}

		if (walletMethod.isEnabled?.(currency) ?? true) {
			methods.push(walletMethod)
		}
	}

	return methods
}
